// @flow
import {
  compose,
  withStateHandlers,
  withHandlers,
  setPropTypes,
  mapProps
} from 'recompose'
import PropTypes from 'prop-types'
import {
  validatePassword,
  validateConfirmPassword
} from '../validations/validations'

const withFormState = withStateHandlers(
  {
    password: '',
    confirmPassword: '',
    passwordError: false,
    confirmPasswordError: false,
    isSending: false
  },
  {
    setPassword: state => password => {
      const passwordError = validatePassword(password)
      const confirmPasswordError =
        password &&
        state.confirmPassword &&
        validateConfirmPassword(password, state.confirmPassword)
      return { password, passwordError, confirmPasswordError }
    },
    setConfirmPassword: state => confirmPassword => {
      const confirmPasswordError = validateConfirmPassword(
        state.password,
        confirmPassword
      )
      return { confirmPassword, confirmPasswordError }
    },
    setIsSending: state => isSending => ({ isSending })
  }
)

const withSubmitHandlers = withHandlers({
  handleSubmit: props => e => {
    const { password, setIsSending, submit } = props
    e.preventDefault()
    setIsSending(true)
    return submit(password)
  },
  onPasswordChange: props => e => {
    const password = e.target.value
    props.setPassword(password)
    //props.setPasswordError(validatePassword(password))
  },
  onPasswordConfirmChange: props => e => {
    const confirmPassword = e.target.value
    props.setConfirmPassword(confirmPassword)
    //props.setConfirmError(validateConfirmPassword(confirmPassword, props.password))
  }
})

const decorator = compose(
  setPropTypes({
    submit: PropTypes.func
  }),
  withFormState,
  withSubmitHandlers,
  mapProps(props => ({
    password: props.password,
    confirmPassword: props.confirmPassword,
    passwordError: props.passwordError,
    confirmPasswordError: props.confirmPasswordError,
    isSending: props.isSending,
    handleSubmit: props.handleSubmit,
    onPasswordChange: props.onPasswordChange,
    onPasswordConfirmChange: props.onPasswordConfirmChange
  }))
)

export default decorator



// WEBPACK FOOTER //
// ./src/services/password-reset/withResetPasswordForm.js